<template>
  <div lang="tr" class="vertical-align-step-0">
    <h3 class="main_question">
      <strong>2/4</strong>
    </h3>
    <h3 class="main_question text-center font-weight-normal mt-4 font-weight-bold">{{ $t('Abonelikler') }}</h3>
    <hr />

    <form method="POST" id="step1" class="mb-4" @submit="sendForm">
      <div
        @click.stop="selectProduct(product)"
        v-for="product in mainProducts"
        :key="product.id"
        class="box-border2"
        v-bind:class="{
          'selected-product': selectedProductsCodes.includes(product.code),
        }"
      >
        <div class="d-flex justify-content-between gap-field py-4">
          <div class="vertical-center ml-1">
            <div>
              <h6 class="mb-1 font-weight-bold">{{ getProductName(product) }}</h6>
              <h6>
                {{
                  formatPrice(Number((product.final_price * 100) / (100 + Number(product.vat_rate))), product.currency)
                }}+KDV
                {{
                  product.type === 'subscription'
                    ? product.period === 'annual'
                      ? '/ ' + $t('Yıl')
                      : '/ ' + $t('Ay')
                    : ''
                }}
              </h6>
            </div>
            <div
              v-if="
                product.code === 'STANDART_TRPACKAGE' ||
                product.code === 'STANDART_TRPACKAGEANNUAL' ||
                product.code === 'ADVANCE_TRPACKAGE' ||
                product.code === 'ADVANCE_TRPACKAGEANNUAL' ||
                product.code === 'NEW_STARTER_TR_ANNUAL'
              "
              :class="getFeatures(product.code).length % 2 === 0 ? 'even-feature' : 'odd-feature'"
            >
              <ul
                class="vertical-center features-spacing main-feature mt-4"
                :class="product.code === 'NEW_STARTER_TR_ANNUAL' ? 'features-full' : 'features-half'"
              >
                <li
                  v-for="feature in getFeatures(product.code)"
                  :key="feature.text"
                  class="col-12"
                  :class="product.code === 'NEW_STARTER_TR_ANNUAL' ? '' : 'col-md-6 '"
                >
                  <span class="d-flex align-items-start feature-item">
                    <span v-tippy="feature.text" class="feature-text">{{ feature.text }}</span>
                    <i
                      v-if="feature.tooltipOptions"
                      v-tippy="feature.tooltipOptions.text"
                      class="fa fa-info-circle feature-icon"
                    ></i>
                  </span>
                  <div v-if="feature.subFeatures" class="subfeature-field">
                    <div v-for="subfeature in feature.subFeatures" :key="subfeature.text" class="subfeature-item">
                      <img src="/img/green-feature.svg" />
                      {{ subfeature.text }}
                      <i
                        v-if="subfeature.tooltipOptions"
                        v-tippy="subfeature.tooltipOptions.text"
                        class="fa fa-info-circle feature-icon"
                      ></i>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <p v-else class="mb-0">{{ getProductDescription(product) }}</p>
          </div>

          <div class="text-center vertical-center product-image">
            <img
              v-if="product.code === 'VIRTUALOFFICESER'"
              src="/img/company-types/virtual-office.svg"
              class="company-type-default"
            />
            <img v-else src="/img/company-types/default.svg" class="company-type-default" />
          </div>
        </div>
        <div>
          <div
            v-if="product.code.includes('VIRTUALOFFICESER')"
            class="startup-additional-package light-blue-bg m-n3 mb-3"
          >
            <transition name="fade">
              <div id="rent-information">
                <h3 class="main_question">Lokasyon</h3>
                <div class="row">
                  <div class="col-12">
                    <div>
                      <div class="row">
                        <div v-for="virtualOffice in virtualOffices" :key="virtualOffice.slug" class="col-4">
                          <div>
                            <label class="container_radio version_2">
                              {{ virtualOffice.name }}
                              <input
                                v-model="company.virtual_office_region"
                                class="required"
                                name="virtual_office_region"
                                type="radio"
                                :value="virtualOffice.slug"
                              />
                              <span class="checkmark"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>

            <div
              class="mt-2"
              v-if="
                company.virtual_office_region === 'kadikoy' || company.virtual_office_region === 'ankara-cevizlidere'
              "
            >
              <h3 class="main_question">{{ $t('Vekalet Hizmeti') }}</h3>
              <div class="mb-3">
                <label class="container_check version_2">
                  {{ $t('Vekalet hizmeti almak istiyorum') }}
                  <template v-if="vkltProduct.net_price === 0">
                    <b class="free-text ml-1">{{ $t('Ücretsiz') }} </b>
                  </template>
                  <template v-else>
                    [
                    {{
                      formatPrice(
                        Number((vkltProduct.net_price * 100) / (100 + Number(vkltProduct.vat_rate))),
                        vkltProduct.currency
                      )
                    }}+KDV
                    {{
                      vkltProduct.type === 'subscription'
                        ? vkltProduct.period === 'annual'
                          ? '/ ' + $t('Yıl')
                          : '/ ' + $t('Ay')
                        : ''
                    }}]
                  </template>
                  <input v-model="proxy_service" :value="true" name="proxy-service" type="checkbox" />
                  <span class="checkmark"></span>
                </label>
              </div>

              <div>
                <a
                  id="proxyService"
                  href="#"
                  class="btn-outline-mukellef btn-radius"
                  @click.stop.prevent="openProxyModal"
                >
                  <i class="fa fa-play link-button-icon"></i><span>{{ $t('Vekalet Hizmetini Neden Almalıyım?') }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h3 class="main_question text-center font-weight-normal mt-4 font-weight-bold">
        {{ $t('Tek seferlik hizmetler') }}
      </h3>
      <hr />
      <div
        @click="selectProduct(product)"
        v-for="product in secondaryProducts"
        class="d-flex justify-content-between box-border gap-field"
        :key="product.id"
        v-bind:class="{
          'selected-product': selectedProductsCodes.includes(product.code),
        }"
      >
        <div class="vertical-center ml-1">
          <div>
            <h6 class="mb-1 font-weight-bold">{{ getProductName(product) }}</h6>
            <h6>
              {{ product.currency
              }}{{ Number(((product.final_price * 100) / (100 + Number(product.vat_rate))).toFixed(2)) }}+KDV
              {{
                product.type === 'subscription'
                  ? product.period === 'annual'
                    ? '/ ' + $t('Yıl')
                    : '/ ' + $t('Ay')
                  : ''
              }}
            </h6>
          </div>
          <div>
            <p>{{ getProductDescription(product) }}</p>
          </div>
        </div>

        <div class="text-center vertical-center product-image">
          <img
            v-if="product.code === 'KOSGEBILERIGIRISIMCILIK'"
            src="/img/company-types/kosgeb-next.svg"
            class="company-type-default"
          />
          <img
            v-else-if="product.code === 'KOSGEBGirisimcilik'"
            src="/img/company-types/kosgeb-new.svg"
            class="company-type-default"
          />
          <img
            v-else-if="product.code === 'markatescil'"
            src="/img/company-types/marka-tescil.svg"
            class="company-type-default"
          />
          <img
            v-else-if="product.code === 'EKSNF'"
            src="/img/company-types/marka-tescil.svg"
            class="company-type-default"
          />
          <img v-else src="/img/company-types/default.svg" class="company-type-medium2" />
        </div>
      </div>
    </form>
    <FeatureExplanationModal :modalTexts="modalTexts" ref="explanationModal" />
    <ProxyServiceModal ref="vkltModal" />
  </div>
</template>
<script>
import RegisterStore from '../../stores/register';
import VirtualOfficeStore from '@/stores/virtual-office';
import ProductStore from '../../stores/product';
import TokenStore from '@/stores/token';
import FeatureExplanationModal from '@/components/modals/FeatureExplanationModal';
import ProxyServiceModal from '@/components/modals/videos/ProxyServiceModal';

export default {
  components: {
    FeatureExplanationModal,
    ProxyServiceModal,
  },
  data() {
    return {
      modalTexts: {},
      products: [],
      mainProducts: [],
      secondaryProducts: [],
      selectedProducts: [],
      exception: [],
      company: null,
      productsCodes: [],
      vkltProduct: {},
      virtualOffices: [],
      proxy_service: false,
    };
  },
  created() {
    $axios.get('company?include=users.channel').then((s) => {
      if (s.data.data.length) {
        this.company = s.data.data[0];

        this.getVirtualOffices(this.company.company_nation_id);
        this.proxy_service = this.company.package != null ? s.data.data[0].package.includes('VKLT') : false;

        if (this.isWebsiteMukellef) {
          if (this.company.is_transferable) {
            this.productsCodes = [
              'STANDART_TRPACKAGE',
              'ADVANCE_TRPACKAGE',
              'STANDART_TRPACKAGEANNUAL',
              'ADVANCE_TRPACKAGEANNUAL',
            ];
            if (
              this.company.buyable_packages &&
              this.company.buyable_packages.includes('NEW_STARTER_TR_ANNUAL') &&
              this.company.companyType.data.code !== 'SELFEMP'
            ) {
              this.productsCodes.push('NEW_STARTER_TR_ANNUAL');
            }
          }
        }

        ProductStore.dispatch('getProductsByAddionalProduct', {
          codes: this.productsCodes,
          companyId: this.company.id,
        }).then((s) => {
          this.products = s.data.data;
          if (!this.showMonthlyPackages) {
            this.products = this.products.filter((product) => {
              return (product.type === 'subscription' && product.period === 'annual') || product.type === 'license';
            });
          }
          if (this.company.users.data[0].channel.data.slug === 'kolektifhouse') {
            this.products = this.products.filter((product) => {
              return product.code !== 'VIRTUALOFFICESER' && product.code !== 'VIRTUALOFFICEST';
            });
          }

          if (this.company.package) {
            this.company.package.forEach(function myFunction(item, index) {
              const findItem = this.products.find((x) => x.code === item);
              if (findItem) {
                this.selectedProducts.push(findItem);
              }
            }, this);
          }
          const index = this.products.findIndex((item) => item.code === 'VKLT');
          if (index !== -1) {
            this.vkltProduct = this.products[index];
            this.products.splice(index, 1);
          }

          this.filterProducts();
          this.endWaiting();
        });
      }
    });
  },
  computed: {
    selectedProductsCodes() {
      if (this.selectedProducts.length) {
        const codeArray = this.selectedProducts.map((item) => item.code);
        return codeArray;
      }
      return [];
    },
    isCorporate() {
      if (this.company) {
        const code = this.company.companyType.data.code;
        if (['LIMITED', 'CORPORATION'].indexOf(code) > -1) {
          return true;
        }
      }
      return false;
    },
    starterFeatures: function () {
      return [
        {
          text: 'Şirket kuruluşu',
        },
        {
          text: 'Online Muhasebe',
          tooltipOptions: {
            header: 'Online Muhasebe',
            text: 'Online muhasebe hizmeti; Mükellef teknoloji çözümleri ve uygulamalarıyla mükelleflerini yönetebilen mali müşavirler tarafından, ilgili asgari ücret tarifelerine uygun olarak verilir.',
          },
          subFeatures: [
            {
              text: 'Muhasebe Hizmeti',
              tooltipOptions: {
                header: 'Online Muhasebe',
                text: 'Online muhasebe hizmeti; Mükellef teknoloji çözümleri ve uygulamalarıyla mükelleflerini yönetebilen mali müşavirler tarafından, ilgili asgari ücret tarifelerine uygun olarak verilir.',
              },
            },
            { text: 'e-Arşiv Fatura' },
            { text: 'Fiş/Fatura Yükleme' },
            { text: 'Yıllık 100 İşlem Kaydı' },
          ],
        },
        {
          text: 'Dijital doküman erişimi',
        },
      ];
    },
    standartFeatures: function () {
      if (!this.isCorporate) {
        return this.$t('TrStandartBireyselMaddeleri');
      } else {
        return this.$t('TrStandartKurumsalMaddeleri');
      }
    },
    standartAdditionalFeatures: function () {
      if (!this.isCorporate) {
        return this.$t('TrStandartAdditionalBireyselMaddeleri');
      } else {
        return this.$t('TrStandartAdditionalKurumsalMaddeleri');
      }
    },
    advanceFeatures: function () {
      if (!this.isCorporate) {
        return this.$t('TrAdvanceBireyselMaddeleri');
      } else {
        return this.$t('TrAdvanceKurumsalMaddeleri');
      }
    },
    advanceAdditionalFeatures: function () {
      if (!this.isCorporate) {
        return this.$t('TrAdvanceAdditionalBireyselMaddeleri');
      } else {
        return this.$t('TrAdvanceAdditionalKurumsalMaddeleri');
      }
    },
    showMonthlyPackages() {
      if (
        this.$store.state.selfMeData.first_channel.show_monthly_packages &&
        this.$store.state.selfMeData.has_partner_link
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    updateCompany(form) {
      return $axios.put('register/' + this.company.id + '/company', form);

      return null;
    },
    updatePackage(form) {
      if (
        this.selectedProductsCodes.includes('VIRTUALOFFICESER') ||
        this.selectedProductsCodes.includes('VIRTUALOFFICESERANNUAL')
      ) {
        return RegisterStore.dispatch('package', { packages: this.selectedProductsCodes, companyNationId: 1 });
      }
      return null;
    },
    openProxyModal() {
      const element = this.$refs.vkltModal.$el;
      $(element).modal('show');
    },
    getVirtualOffices(companyNationId) {
      VirtualOfficeStore.dispatch('getVirtualOffices', companyNationId).then((s) => {
        const virtualOffices = s.data.data;

        this.virtualOffices = virtualOffices;

        this.company.virtual_office_region =
          this.company.virtual_office_region &&
          this.virtualOffices.find((x) => x.slug === this.company.virtual_office_region)
            ? this.company.virtual_office_region
            : 'kadikoy';
      });
    },
    openModalText(texts) {
      this.modalTexts = texts;
      const element = this.$refs.explanationModal.$el;
      $(element).modal('show');
    },
    getFeatures(code) {
      if (code.includes('STANDART')) {
        return this.standartFeatures.concat(this.standartAdditionalFeatures);
      }
      if (code.includes('STARTER')) {
        return this.starterFeatures;
      } else {
        return this.advanceFeatures.concat(this.advanceAdditionalFeatures);
      }
    },
    selectProduct(product) {
      if (this.selectedProductsCodes.includes(product.code)) {
        const index = this.selectedProducts.findIndex((item) => item.code === product.code);
        this.selectedProducts.splice(index, 1);
      } else {
        if (this.selectedProducts.length) {
          const subsProduct = this.selectedProducts.find((item) => item.type === 'subscription');
          if (subsProduct) {
            const period = subsProduct.period;
            if (product.period !== period && product.type === 'subscription') {
              this.$toasted.error('Aynı anda aylık ve yıllık paket seçemezsiniz.');
              return;
            }
          }
          if (product.is_package) {
            const index = this.selectedProducts.findIndex((item) => item.is_package);
            if (index !== -1) {
              this.selectedProducts.splice(index, 1);
            }
          }
        }

        this.selectedProducts.push(product);
      }
    },
    sendForm(callback) {
      let selectedProducts = this.selectedProductsCodes;
      if (
        (this.proxy_service === true && this.company.virtual_office_region === 'kadikoy') ||
        this.company.virtual_office_region === 'ankara-cevizlidere'
      ) {
        this.company.proxy_service = this.proxy_service;
      }
      if (!selectedProducts.length) {
        this.$toasted.error(this.$t('AlertMessages.Lütfen bir ürün seçin'));
        return;
      }
      let isSelectedVirtualOffice;

      if (selectedProducts.includes('VIRTUALOFFICESER')) {
        isSelectedVirtualOffice = true;
        if (!selectedProducts.includes('VIRTUALOFFICEST')) {
          selectedProducts.push('VIRTUALOFFICEST');
        }
      } else {
        isSelectedVirtualOffice = false;
        if (selectedProducts.includes('VIRTUALOFFICESER')) {
          const index = selectedProducts.indexOf('VIRTUALOFFICEST');
          if (index > -1) {
            array.splice(index, 1);
          }
        }
      }
      const isSelectedAllVirtualOffice = isSelectedVirtualOffice || selectedProducts.includes('VIRTUALOFFICESERANNUAL');

      if (isSelectedAllVirtualOffice) {
        this.company.virtual_office = true;
        this.company.office_status = 'virtual';
      }

      if (this.company.proxy_service && isSelectedAllVirtualOffice) {
        const vkltIndex = this.company.package ? this.company.package.indexOf('VKLT') : -1;
        if (vkltIndex === -1) {
          selectedProducts.push('VKLT');
        }
      } else {
        const valuesToRemove = ['VKLT'];
        selectedProducts = selectedProducts.filter((i) => !valuesToRemove.includes(i));
      }

      this.company.package = selectedProducts;
      this.startWaiting();

      $axios.all([this.updateCompany(this.company)]).then(
        $axios.spread((first_response, second_response) => {
          if (first_response) {
            if (first_response.data.success === false) {
              this.$toasted.error(this.$t('AlertMessages.Lütfen bir ürün seçin'));
              this.endWaiting();
              return;
            }
            TokenStore.commit('setCompanyId', first_response.data.data.id);
            this.$store.commit('setisSelectedVirtualOffice', isSelectedVirtualOffice);
          }

          callback();
        })
      );
    },
    filterProducts() {
      const excludedProducts = [];
      if (this.company.companyType.data.code === 'SELFEMP') {
        excludedProducts.push('STANDART_TRPACKAGE', 'STANDART_TRPACKAGEANNUAL', 'NEW_STARTER_TR_ANNUAL');
      }
      this.mainProducts = this.products
        .filter((product) => {
          return product.type === 'subscription' && !excludedProducts.includes(product.code);
        })
        .sort(this.dynamicSort('order'));

      this.secondaryProducts = this.products
        .filter((product) => {
          return product.type !== 'subscription';
        })
        .sort(this.dynamicSort('order'));
    },
    dynamicSort(property) {
      let sortOrder = 1;
      if (property[0] === '-') {
        sortOrder = -1;
        property = property.substr(1);
      }
      return function (a, b) {
        const firstValue = a[property];
        const secondValue = b[property];
        if (sortOrder === 1) {
          return (
            (firstValue === null) - (secondValue === null) || +(firstValue > secondValue) || -(firstValue < secondValue)
          );
        }
        return (
          (firstValue === null) - (secondValue === null) || -(firstValue > secondValue) || +(firstValue < secondValue)
        );
      };
    },
  },
};
</script>
<style lang="less" scoped>
.subfeature-field {
  background: #f9f9f9;
  border-radius: 4px;
  color: #4b4b4b;
  padding: 8px;
  display: flex;

  justify-content: space-between;
  gap: 4px;
  margin-top: 4px;
  flex-direction: row;
  @media (max-width: 1100px) {
    flex-direction: column;
    align-items: flex-start;
  }
  @media (max-width: 992px) {
    flex-direction: row;
    align-items: center;
  }
  @media (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
  }
}

.subfeature-item {
  display: flex;
  align-items: flex-start;
  font-size: 12px;
  line-height: 24px;
  img {
    width: 16px;
    margin-right: 2px;
    margin-top: 4px;
  }
  i {
    margin-left: 6px;
    margin-top: 5px;
  }
}

.features-half,
.features-full {
  li {
    margin-bottom: 6px;
  }
}

.even-feature .main-feature li:not(:nth-last-of-type(-n + 2)) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.odd-feature .main-feature li:not(:nth-last-of-type(-n + 1)) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.features-half,
.features-full,
.features-additional-half {
  display: flex;
  flex-wrap: wrap;

  li {
    .feature-item {
      flex-flow: wrap;
      .feature-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 0.5rem;
      }
    }

    @media (max-width: 576px) {
      flex-basis: 100%;
      max-width: 100%;
    }
  }
}

.features-full {
  &.main-feature li {
    padding: 0rem 0rem 0.5rem 0;
    &:not(:last-child) {
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    }
  }
}

.virtual-office-package {
  background: #f4f9fc;
  padding: 16px 22px;
  display: none;
  margin: 1rem -1.5rem -0.5rem -1.5rem;
}

.virtual-office-package .features {
  text-align: right;
}

.selected .virtual-office-package {
  display: block;
}

.virtual-office img {
  height: 32px;
}

.features {
  font-size: 12px;
}

.vertical-center {
  margin-top: auto;
  margin-bottom: auto;
}

h3.main_question {
  font-size: 1rem;
}
</style>
